import React from 'react'
import { compose } from 'redux'

import withOAuthConnectionStatus from './withOAuthConnectionStatus'

const CalendarSettingsLink = ({
  isConnected,
}) => {
  return (
    <a href="/meetings">
      {isConnected ? 'View meeting settings' : 'Connect your calendar'}
    </a>
  )
}

export default compose(
  withOAuthConnectionStatus,
)(CalendarSettingsLink)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ContactInfo/ManageCalendarLink.js